// Id de la sesión de compra: une los pasos de una misma persona en un evento
// antes de que exista la orden. Vive en sessionStorage, que muere con la
// pestaña: una compra en otra pestaña es otra sesión.

const sessionKey = (eventId: string) => `${eventId}_checkout_session`;

const randomUuid = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Navegadores internos viejos sin crypto.randomUUID: UUID v4 a mano.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === 'x' ? random : (random % 4) + 8;
    return value.toString(16);
  });
};

const getCheckoutSessionId = (eventId: string): string => {
  try {
    const existing = sessionStorage.getItem(sessionKey(eventId));
    if (existing) {
      return existing;
    }
    const created = randomUuid();
    sessionStorage.setItem(sessionKey(eventId), created);
    return created;
  } catch {
    // Sin storage cada paso queda suelto, pero se mide igual.
    return randomUuid();
  }
};

export default getCheckoutSessionId;
